<template>
  <div class="sale-qrcode">
    <el-card>
      <el-form :inline="true" :model="filter" class="form-inline" size="small">
        <el-form-item label="渠道活码名称：">
          <el-input v-model="filter.name" placeholder="请输入渠道活码名称" />
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="filter.status" placeholder="请选择状态">
            <el-option label="全部" value="" />
            <el-option label="正常" value="1" />
            <el-option label="禁用" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="dateList"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-row type="flex" style="margin-top: 10px;">
      <el-card :class="['menu-card', isCollapse && 'collapse']">
        <el-row type="flex" justify="space-between" align="middle">
          <p class="menu-title">
            <i class="el-icon-s-fold" @click="isCollapse = !isCollapse" />
            <span v-show="!isCollapse">渠道分组</span>
          </p>
          <el-button v-show="!isCollapse" type="primary" size="small" @click="toAddClassify">添加分组</el-button>
        </el-row>
        <el-menu class="menu-vertical" :collapse="isCollapse">
          <el-submenu v-for="item of classifyList" :key="item.id" :index="item.id" :class="[filter.classifyId === item.id && 'active-menu']" @click.stop.native="handleOpen(item)">
            <template slot="title">
              <i class="el-icon-folder" />
              <el-row type="flex" justify="space-between" align="middle" class="flex-inline">
                <span>{{ item.name }}</span>
                <span class="edit-container">
                  <i class="eidt-icon el-icon-folder-add" @click.stop="handleAddChildClassify(item.id)" />
                  <template v-if="item.id !== defaultClassifyId">
                    <i class="eidt-icon el-icon-edit-outline" @click.stop="handleEditClassif({ ...item, pid: '' })" />
                    <i v-if="hasAuthority('deleteMenu')" class="eidt-icon el-icon-delete" @click.stop="handleDeleteClassif(item.id)" />
                  </template>
                </span>
              </el-row>
            </template>
            <el-menu-item-group v-if="classifyChilds[item.id]">
              <el-menu-item
                v-for="v of classifyChilds[item.id]"
                :key="v.id"
                :index="v.id"
                :class="[filter.classifyId === v.id && 'active-menu']"
                @click.stop.native="handleOpen(item, v)"
              >
                <el-row type="flex" justify="space-between" align="middle">
                  {{ v.name }}
                  <span>
                    <i class="eidt-icon el-icon-edit-outline" @click.stop="handleEditClassif({ ...v, pid: item.id })" />
                    <i v-if="hasAuthority('deleteMenu')" class="eidt-icon el-icon-delete" @click.stop="handleDeleteClassif(v.id, item.id)" />
                  </span>
                </el-row>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-card>
      <el-card style="flex:1">
        <el-row type="flex" justify="space-between" align="middle">
          <span>{{ currentPath }}</span>
          <div>
            <el-button type="primary" size="small" @click="handleCreate">新建活码</el-button>
            <el-button type="primary" size="small" @click="handleAuthorizationPhone">手机号授权二维码</el-button>
          </div>
        </el-row>
        <el-table v-loading="loading" :data="list" border style="margin-top: 10px">
          <el-table-column align="center" label="渠道活码名称" prop="name" min-width="150" />
          <el-table-column align="center" label="当前用户总数" prop="currentContactCnt" min-width="130" />
          <el-table-column align="center" label="添加好友总次数" prop="addFriendTimes" min-width="130" />
          <el-table-column align="center" label="删除好友总次数" prop="delFriendTimes" min-width="140" />
          <!-- <el-table-column align="center" label="被客户删除总次数" prop="delByContactTimes" min-width="150" /> -->
          <el-table-column align="center" label="状态" prop="status" min-width="80">
            <template v-slot="{ row }">
              <span v-if="row.status === 1">正常</span>
              <span v-else-if="row.status === 2">禁用</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注" width="178">
            <template v-slot="{ row }">
              <template v-if="row.remarks">
                <el-tooltip
                  :disabled="row.remarks.length < 10"
                  :open-delay="200"
                  placement="top"
                >
                  <div slot="content" class="tooltip-content">{{ row.remarks }}</div>
                  <span class="tooltip-index">{{ row.remarks ? (row.remarks.substring(0 ,10) + '...') : '-' }}</span>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" prop="insertDate" min-width="180" />
          <el-table-column align="center" label="操作" prop="" width="240" fixed="right">
            <template v-slot="{ row }">
              <el-button v-if="row.status === 1" :disabled="!hasAuthority('app1SaleQrcodeDisable')" type="text" class="operate-button-text" @click="handleToggleStatus(row)">禁用</el-button>
              <el-button v-else-if="row.status === 2" :disabled="!hasAuthority('app1SaleQrcodeDisable')" type="text" class="operate-button-text" @click="handleToggleStatus(row)">启用</el-button>
              <el-button type="text" class="operate-button-text" @click="handleEdit(row)">编辑</el-button>
              <el-button type="text" class="operate-button-text" @click="toStatistics(row)">统计</el-button>
              <template v-if="row.codeFlag === 2">
                <el-button type="text" class="operate-button-text" @click="downloadQrcode(row.codeUrl)">下载二维码</el-button>
                <el-button type="text" class="operate-button-text" @click="toShowQrcodePath(row.codeUrl)">图片地址链接</el-button>
              </template>
              <el-button v-else type="text" class="operate-button-text" @click="paintQrcode(row)">生成二维码</el-button>
              <el-button type="text" class="operate-button-text" @click="handleCopy(row)">复制数据</el-button>
              <el-button :disabled="!hasAuthority('app1SaleQrcodeDelete')" type="text" class="operate-button-text" @click="handleDelete(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-card>
    </el-row>
    <!-- 新建活码 -->
    <LiveCodeManage ref="liveCodeManageEl" :classifyId="filter.classifyId" @close="getList()" />
    <Statistics ref="statisticsEl" />
    <PaintQrcode ref="paintQrcodeEl" @close="getList()" />
    <el-dialog title="图片地址链接" :visible.sync="pathViewDialog" width="580px" class="path-view-dialog">
      <el-row>
        <el-col :span="5">图片地址链接: </el-col>
        <el-col :span="19">
          <a href="javascript:;">{{ qrcodePath }}</a>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :data-clipboard-text="qrcodePath" class="qrcode-path" @click="copyPath">复制链接</el-button>
        <el-button type="" size="small" @click="pathViewDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="手机号授权二维码" :visible.sync="showAuthPhoneCodeDialog" width="460px" class="path-view-dialog">
      <canvas v-loading="picLoding" id="canvas" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :disabled="picLoding" @click="handleDownLoadAuthQrcode">下载</el-button>
        <el-button type="" size="small" @click="showAuthPhoneCodeDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="classifyFormTitle" :visible.sync="showClassifyFormDialog" :close-on-click-modal="false" width="460px" class="path-view-dialog">
      <el-form ref="classifyFormEl" :model="classifyForm" :rules="classifyFromRules" label-width="94px" size="small">
        <el-form-item :label="classifyForm.pid ? '子分组名称' : '分组名称'" prop="name">
          <el-input v-model="classifyForm.name" placeholder="请输入分组名称" maxlength="10" show-word-limit />
        </el-form-item>
        <el-form-item v-if="!classifyForm.pid" label="分组序号" prop="sortNum">
          <el-input v-model="classifyForm.sortNum" placeholder="请输入分组序号,数值越小越靠前" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :disabled="submitLoding" @click="handleManageQwClassify">保存</el-button>
        <el-button type="" size="small" @click="showClassifyFormDialog = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LiveCodeManage from './modules/liveCodeManage.vue'
import Statistics from './modules/statistics.vue'
import PaintQrcode from './modules/paintQrcode.vue'
import { ImageMoudel } from '@/libs/mixin/ImageMoudel'
import {
  getQwLiveCodeList,
  toggleStatus,
  delQwLiveCode,
  getOauth2Url,
  getQwClassifyByPid,
  manageQwClassify,
  getCodeNum,
  delQwClassify
} from '@/api/admin/saleQrcode.js'
import Clipboard from 'clipboard'
import QRCode from 'qrcode'

export default {
  name: 'SaleQrcode',

  mixins: [ImageMoudel],
  components: { LiveCodeManage, Statistics, PaintQrcode },
  data () {
    return {
      currentPath: '',
      defaultClassifyId: null,
      filter: {
        classifyId: '',
        page: 1,
        limit: 10,
        name: '',
        status: '',
        insertStartDate: '',
        insertEndDate: ''
      },
      isCollapse: false,
      classifyList: [],
      classifyChilds: {},
      total: 0,
      loading: false,
      list: [],
      pathViewDialog: false,
      qrcodePath: '',
      showAuthPhoneCodeDialog: false,
      picLoding: false,
      showClassifyFormDialog: false,
      classifyForm: {
        pid: 0,
        name: '',
        sortNum: ''
      },
      classifyFromRules: {
        name: [
          { required: true, message: '请输入分组名称', trigger: 'blur' }
        ]
      },
      submitLoding: false,
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.filter.insertStartDate, this.filter.insertEndDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.insertStartDate = v[0] + ' 00:00:00' || ''
          this.filter.insertEndDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.insertStartDate = ''
          this.filter.insertEndDate = ''
        }
      }
    },
    classifyFormTitle () {
      if (this.classifyForm.pid) {
        if (this.classifyForm.id) {
          return '编辑子分组'
        }
        return '添加子分组'
      } else {
        if (this.classifyForm.id) {
          return '编辑分组'
        }
      }
      return '添加分组'
    }
  },
  created() {
    this.handleGetClassify(0, () => {
      this.init()
    })
  },
  methods: {
    init () {
      if (this.classifyList.length !== 0) {
        const t = this.classifyList.find(item => item.isDefault === 1)
        this.filter.classifyId = t ? t.id : ''
        this.defaultClassifyId = this.filter.classifyId
      }
      this.currentPath = '默认分组'
      this.getList()
    },
    // 分组模块
    handleOpen(v = null, s = null) {
      if (v.id && !s) {
        this.filter.classifyId = v.id
        this.currentPath = v.name
        this.handleGetClassify(v.id)
      } else if (s) {
        this.filter.classifyId = s.id
        this.currentPath = `${v.name} / ${s.name}`
      }
      this.search()
    },
    // 获取分组
    handleGetClassify (pid = 0, callback = null) {
      getQwClassifyByPid({ pid }).then(({ code, data }) => {
         if (code === 0) {
          if (pid) {
            this.$set(this.classifyChilds, pid, data)
          } else {
            this.classifyList = data
            callback && callback()
          }
         }
      })
    },
    // 点击添加
    toAddClassify () {
      this.classifyForm = this.$options.data().classifyForm
      this.showClassifyFormDialog = true
    },
    // 添加分组
    handleManageQwClassify () {
      this.$refs.classifyFormEl.validate(valid => {
        if (valid) {
          this.submitLoding = true
          manageQwClassify(this.classifyForm).then(({ code }) => {
            if (code === 0) {
              const tips = this.classifyForm.id ? '编辑分组成功!' : '添加分组成功!'
              this.$message.success(tips)
              this.handleGetClassify()
              if (this.classifyForm.pid) {
                this.handleGetClassify(this.classifyForm.pid)
              }
              this.showClassifyFormDialog = false
            }
          }).finally(() => {
            this.submitLoding = false
          })
        }
      })
    },
    // 点击添加子分组
    handleAddChildClassify (id) {
      this.classifyForm = this.$options.data().classifyForm
      this.classifyForm.pid = id
      this.showClassifyFormDialog = true
    },
    // 点击编辑
    handleEditClassif ({ id, name, sortNum, pid = '' }) {
      this.classifyForm = this.$options.data().classifyForm
      this.classifyForm.id = id
      this.classifyForm.name = name
      this.classifyForm.sortNum = sortNum
      this.classifyForm.pid = pid
      this.showClassifyFormDialog = true
    },
    // 点击删除
    handleDeleteClassif (id, pid = '') {
      getCodeNum({ id }).then(({ code, data }) => {
        if (code === 0) {
          let tips = '是否确认删除？'
          if (data !== 0) {
            tips = '当前分组下面有活码，请删除活码再删除分组!'
          }
          this.$confirm(tips, '提示', {
            showCancelButton: data === 0,
            cancelButtonText: '取消',
            confirmButtonText: data === 0 ? '删除' : '确认',
            closeOnClickModal: false
          }).then(() => {
            if (data === 0) {
              delQwClassify({ id }).then(({ code }) => {
                if (code === 0) {
                  if (pid) {
                    this.handleGetClassify(pid)
                  }
                  if (this.filter.classifyId === id) {
                    this.handleGetClassify(0, () => {
                      this.init()
                    })
                  } else {
                    this.handleGetClassify()
                  }
                  this.$message.success('删除成功!')
                }
              })
            }
          })
        }
      })
    },
    async getList () {
      this.loading = true
      const res = await getQwLiveCodeList(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
      setTimeout(() => {
        this.loading = false
      }, 300)
    },
    // 点击新建活码
    handleCreate() {
      this.$refs.liveCodeManageEl.init(false)
    },
    // 点击手机号码授权二维码
    handleAuthorizationPhone() {
      this.picLoding = true
      getOauth2Url().then(({ code, data }) => {
        if (code === 0) {
          const canvas = document.getElementById('canvas')
          QRCode.toCanvas(canvas, data, function (error) {
            if (error) console.error(error)
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.picLoding = false
        }, 300)
      })
      this.showAuthPhoneCodeDialog = true
    },
    handleDownLoadAuthQrcode () {
      const canvas = document.getElementById('canvas')
      canvas.toBlob(blob => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        const event = new MouseEvent('click')
        a.download = '手机号授权二维码.png'
        a.href = url
        a.dispatchEvent(event)
        URL.revokeObjectURL(url)
      })
    },
    // 切换状态
    handleToggleStatus({ status, id }) {
      this.$confirm(
        status === 1 ? '请谨慎操作，禁用后二维码将失效，再次启用时，需重新下载二维码，是否确认操作' : '重新启用时，请下载最新二维码',
        '确认',
        {
          type: 'warning',
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        }).then(() => {
          toggleStatus({ id }).then(({ code }) => {
            if (code === 0) {
              this.$message.success('操作成功!')
              this.getList()
            }
          })
        })
    },
    // 点击编辑活码
    handleEdit(row) {
      this.$refs.liveCodeManageEl.init(row)
    },
    // 点击统计
    toStatistics(v) {
      this.$refs.statisticsEl.init(v)
    },
    // 点击下载
    downloadQrcode(path) {
      this.downloadIamge(path, 'qrcode')
    },
    // 点击图片链接地址
    toShowQrcodePath(path) {
      this.qrcodePath = path
      this.pathViewDialog = true
    },
    // 点击绘制二维码
    paintQrcode(row){
      this.$refs.paintQrcodeEl.init(row)
    },
    // 点击复制数据
    handleCopy (row) {
      this.$confirm('是否确定复制数据', '提示', {
        confirmButtonText: '复制并编辑',
        cancelButtonText: '取消'
      }).then(() => {
        this.$refs.liveCodeManageEl.init({ ...row, isCopy: true })
      })
    },
    // 点击删除
    handleDelete (id) {
      this.$confirm('是否确定删除数据', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        delQwLiveCode({ id }).then(({ code }) => {
          if (code === 0) {
            this.$message.success('删除成功!')
            this.getList()
          }
        })
      })
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      this.filter = this.$options.data().filter
      if (this.classifyList.length !== 0) {
        const t = this.classifyList.find(item => item.isDefault === 1)
        this.filter.classifyId = t ? t.id : ''
        this.defaultClassifyId = this.filter.classifyId
      }
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    copyPath() {
      const clipboard = new Clipboard('.qrcode-path')
      clipboard.on('success', (e) => {
        this.$message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        this.$message.error('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.menu-card {
  margin-right: 10px;
  .menu-vertical {
    margin-top: 10px;
  }
  .menu-title {
    line-height: 32px;
    i {
      padding-right: 10px;
      font-size: 18px;
      vertical-align: middle;
      cursor: pointer;
    }
    span {
      font-size: 14px;
      vertical-align: middle;
    }
  }
  ::v-deep .el-card__body {
    width: 360px;
    transition: all 0.16s ease-in;
    .el-icon-folder {
      color: #409EFF;
    }
    .flex-inline {
      width: calc(100% - 30px);
      display: inline-flex !important;
    }
  }
  ::v-deep .el-menu {
    border-color: transparent;
    .edit-container {
      margin-right: 20px;
    }
    .eidt-icon {
      opacity: 0;
      font-size: 14px;
      color: #909399;
      transition: all 0.15s ease-in;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
    .el-menu-item {
      padding-right: 40px;
      &.active-menu {
        background-color: #EDF2FD;
      }
      &.is-active {
        color: #303133;
      }
      &:hover {
        .eidt-icon {
          opacity: 1;
        }
      }
    }
    .el-submenu__title {
      &:hover {
        .eidt-icon {
          opacity: 1;
        }
      }
    }
    .active-menu {
      .el-submenu__title {
        background-color: #EDF2FD;
      }
    }
  }
  &.collapse {
    ::v-deep .el-card__body {
      width: auto;
    }
  }
}
.operate-button-text {
  padding: 0;
}
.tooltip-content {
  max-width: 300px;
}
.tooltip-index {
  cursor: pointer;
}
#canvas {
  width: 100% !important;
  height: auto !important;
}
</style>
